import { buildService } from './decorated-service';
import {
  StaticUGMAUTMAApplication,
  OptionalStaticUGMAUTMAApplication,
  UGMAUTMAApplication
} from '../../../core/types/applications/taxable-applications/ugmautma-application';
import {
  handleSubmissionError,
  purgeEmptyFields,
  removeExtraAddressFields,
  submissionTimeOutErrorCode
} from './util';
import { consumerTypes } from '../utils';

const UGMAUTMASubmissionApi = buildService(
  '/new-account-svc/service/v2/account/ugma-utma'
);

const FONASUUGMAUTMASubmissionApi = buildService(
  '/new-account-svc/service/front-office/v2/account/ugma-utma'
);

export const UGMAUTMAApplicationService = (
  args: OptionalStaticUGMAUTMAApplication,
  consumerName
): Promise<any> => {
  const validated: StaticUGMAUTMAApplication = UGMAUTMAApplication.check(args);
  const submissionPayload = purgeEmptyFields(validated);
  const finalSubmissionPayload = removeExtraAddressFields(submissionPayload);

  const apiEndpoint =
    consumerName === consumerTypes.FONASU
      ? FONASUUGMAUTMASubmissionApi
      : UGMAUTMASubmissionApi;

  return apiEndpoint.add(finalSubmissionPayload, {
    submissionTimeOutErrorCode,
    handleServiceResponse: handleSubmissionError
  });
};
